import apiClient from './client';

export const getHomeBanner = async (locale: string) => {
  try {
    const response = await apiClient.get(`home-banner?locale=${locale}&populate[0]=banner.image&populate[1]=Logo`);
    return response.data;
  } catch (error) {
    console.error('Error fetching home banner:', error);
    throw error;
  }
};

export const getNavigation = async (locale: string) => {
  try {
    const basePopulates = 'populate[0]=item.*&populate[1]=item.subMenu&populate[2]=item.subMenu.Tier3';
    const query = locale ? `navigation?locale=${locale}&${basePopulates}` : `home?${basePopulates}`;
    const response = await apiClient.get(query);
    return response.data;
  } catch (error) {
    console.error('Error fetching navigation:', error);
    throw error;
  }
};

export const getInformation = async (locale: string) => {
  try {
    const basePopulates = 'populate[0]=Seo';
    const query = locale ? `footer?locale=${locale}&${basePopulates}` : `home?${basePopulates}`;
    const response = await apiClient.get(query);
    return response.data;
  } catch (error) {
    console.error('Error fetching service product:', error);
    throw error;
  }
};

export const getServiceProduct = async (locale: string) => {
  try {
    const basePopulates = 'populate[0]=Cards&populate[1]=video&populate[2]=Cards.icon&populate[3]=video.Video';
    const query = locale ? `home?locale=${locale}&${basePopulates}` : `home?${basePopulates}`;
    const response = await apiClient.get(query);
    return response.data;
  } catch (error) {
    console.error('Error fetching service product:', error);
    throw error;
  }
};

export const getFunctionTeachingLearning = async (locale: string) => {
  try {
    const basePopulates = 'populate[0]=TeachingLearning&populate[2]=TeachingLearning.Header&populate[4]=TeachingLearning.Item&populate[20]=TeachingLearning.Item.Icon';
    const query = locale ? `home?locale=${locale}&${basePopulates}` : `home?${basePopulates}`;
    const response = await apiClient.get(query);
    return response.data;
  } catch (error) {
    console.error('Error fetching function teaching learning:', error);
    throw error;
  }
};

export const getLearningToolsEditor = async (locale: string) => {
  try {
    const basePopulates = 'populate[5]=OtherTools.Header&populate[6]=OtherTools.Card&populate[12]=Product_specifications&populate[16]=Product_specifications.Header&populate[21]=OtherTools.Card.Icon';
    const query = locale ? `home?locale=${locale}&${basePopulates}` : `home?${basePopulates}`;
    const response = await apiClient.get(query);
    return response.data;
  } catch (error) {
    console.error('Error fetching learning tools editor:', error);
    throw error;
  }
};

export const getMaterialLibrary = async (locale: string) => {
  try {
    const basePopulates = 'populate[0]=MaterialLibrary.Header&populate[1]=MaterialLibrary.Cards&populate[2]=MaterialLibrary.Ball';
    const query = locale ? `home?locale=${locale}&${basePopulates}` : `home?${basePopulates}`;
    const response = await apiClient.get(query);
    return response.data;
  } catch (error) {
    console.error('Error fetching material library:', error);
    throw error;
  }
};

export const getServiceAIDictationWizard = async (locale: string) => {
  try {
    const basePopulates = 'populate[0]=Card_video.Cards&populate[2]=Card_video.Cards.icon&populate[3]=Content&populate[4]=Content.Video';
    const query = locale ? `service-ai-dictation-wizard?locale=${locale}&${basePopulates}` : `home?${basePopulates}`;
    const response = await apiClient.get(query);

    return response.data;
  } catch (error) {
    console.error('Error fetching about:', error);
    throw error;
  }
};

export const getServiceAIAnalyticsAssistant = async (locale: string) => {
  try {
    const basePopulates = 'populate[0]=Card_video.Cards&populate[2]=Card_video.Cards.icon&populate[3]=Content&populate[4]=Content.Video';
    const query = locale ? `service-ai-learning-analytics-wizard?locale=${locale}&${basePopulates}` : `home?${basePopulates}`;
    const response = await apiClient.get(query);

    return response.data;
  } catch (error) {
    console.error('Error fetching about:', error);
    throw error;
  }
};

export const getServiceAILearningChatbot = async (locale: string) => {
  try {
    const basePopulates = 'populate[0]=Card_video.Cards&populate[2]=Card_video.Cards.icon&populate[3]=Content&populate[4]=Content.Video';
    const query = locale ? `service-ai-learning-chatbot?locale=${locale}&${basePopulates}` : `home?${basePopulates}`;
    const response = await apiClient.get(query);

    return response.data;
  } catch (error) {
    console.error('Error fetching about:', error);
    throw error;
  }
};


export const getServiceAIMarkingWizard = async (locale: string) => {
  try {
    const basePopulates = 'populate[0]=Card_video.Cards&populate[2]=Card_video.Cards.icon&populate[3]=Content&populate[4]=Content.Video';
    const query = locale ? `service-ai-marking-wizard?locale=${locale}&${basePopulates}` : `home?${basePopulates}`;
    const response = await apiClient.get(query);

    return response.data;
  } catch (error) {
    console.error('Error fetching about:', error);
    throw error;
  }
};


export const getServiceAISpeckingCoach = async (locale: string) => {
  try {
    const basePopulates = 'populate[0]=Cards&populate[1]=Cards.icon&populate[2]=Content.Editor&populate[3]=Content.Video';
    const query = locale ? `service-ai-speaking-coach?locale=${locale}&${basePopulates}` : `home?${basePopulates}`;
    const response = await apiClient.get(query);

    return response.data;
  } catch (error) {
    console.error('Error fetching about:', error);
    throw error;
  }
};

export const getServiceAIQuizWizard = async (locale: string) => {
  try {
    const basePopulates = 'populate[0]=Cards.icon&populate[1]=Step_title&populate[2]=Step&populate[3]=Video.Video';
    const query = locale ? `service-ai-quiz-wizard?locale=${locale}&${basePopulates}` : `service-ai-quiz-wizard?${basePopulates}`;
    const response = await apiClient.get(query);
    return response.data;
  } catch (error) {
    console.error('Error fetching service AI quiz wizard:', error);
    throw error;
  }
};

export const getOctoDapAiCampusHub = async (locale: string) => {
  try {
    const basePopulates = 'populate[0]=Cards.Cards&populate[1]=Cards.Cards.icon&populate[2]=CommonAgenticWorkflow.Header&populate[3]=CommonAgenticWorkflow.Card&populate[4]=CommonAgenticWorkflow.Card.Icon';
    const query = locale ? `octo-dap-ai-campus-hub?locale=${locale}&${basePopulates}` : `octo-dap-ai-campus-hub?${basePopulates}`;
    const response = await apiClient.get(query);
    return response.data;
  } catch (error) {
    console.error('Error fetching octo dap ai campus hub:', error);
    throw error;
  }
};

export const getOctoDapAiCampusHubDynamic = async (locale: string) => {
  try {
    const basePopulates = 'populate[0]=Content.EditorMedia&populate[1]=Content.EditorMedia.Graphic&populate[2]=Content.Cards&populate[3]=Content.Cards.Icon';
    const query = locale ? `octo-dap-ai-campus-hub?locale=${locale}&${basePopulates}` : `octo-dap-ai-campus-hub?${basePopulates}`;
    const response = await apiClient.get(query);
    return response.data;
  } catch (error) {
    console.error('Error fetching octo dap ai campus hub:', error);
    throw error;
  }
};

export const getOctoDAPAIWorkplaceHub = async (locale: string) => {
  try {
    const basePopulates = 'populate[0]=Cards.Cards&populate[1]=Cards.Cards.icon&populate[2]=CommonAgenticWorkflow.Header&populate[3]=CommonAgenticWorkflow.Card&populate[4]=CommonAgenticWorkflow.Card.Icon';
    const query = locale ? `octo-dap-ai-workplace-hub?locale=${locale}&${basePopulates}` : `octo-dap-ai-workplace-hub?${basePopulates}`;
    const response = await apiClient.get(query);
    return response.data;
  } catch (error) {
    console.error('Error fetching octo dap ai campus hub:', error);
    throw error;
  }
};

export const getOctoDAPAIWorkplaceHubDynamic = async (locale: string) => {
  try {
    const basePopulates = 'populate[0]=Content.EditorMedia&populate[1]=Content.EditorMedia.Graphic&populate[2]=Content.Card&populate[3]=Content.Card.icon&populate[4]=Content.Graphic';
    const query = locale ? `octo-dap-ai-workplace-hub?locale=${locale}&${basePopulates}` : `octo-dap-ai-workplace-hub?${basePopulates}`;
    const response = await apiClient.get(query);
    return response.data;
  } catch (error) {
    console.error('Error fetching octo dap ai campus hub:', error);
    throw error;
  }
};

export const getHomeData = async (locale: string) => {
  try {
    const basePopulates = 'populate[0]=AboutOctopus.Header&populate[1]=CoreServices.Header&populate[2]=CoreServices.Card&populate[3]=CoreServices.Card.Icon';
    const query = locale ? `home-page?locale=${locale}&${basePopulates}` : `home-page?${basePopulates}`;
    const response = await apiClient.get(query);
    return response.data;
  } catch (error) {
    console.error('Error fetching octo dap ai campus hub:', error);
    throw error;
  }
};

export const getHomeToolsData = async (locale: string) => {
  try {
    const basePopulates = 'populate[0]=Tools&populate[1]=Tools.Icon&populate[2]=CoreProducts.Header&populate[3]=CoreProducts.Card&populate[4]=CoreProducts.Card.Icon';
    const query = locale ? `home-page?locale=${locale}&${basePopulates}` : `home-page?${basePopulates}`;
    const response = await apiClient.get(query);
    return response.data;
  } catch (error) {
    console.error('Error fetching octo dap ai campus hub:', error);
    throw error;
  }
};


export const getLatestUpdatesPostData = async (locale: string) => {
  try {
    const basePopulates = 'populate[0]=news_posts&populate[1]=news_posts.Media.Media&populate[2]=news_posts.Content&populate[3]=news_posts.Category';
    const query = locale ? `latest-update?locale=${locale}&${basePopulates}&sort[4]=news_posts.Date:asc` : `latest-update?${basePopulates}`;
    const response = await apiClient.get(query);
    return response.data;
  } catch (error) {
    console.error('Error fetching latest updates post data:', error);
    throw error;
  }
};

export const getPostDetailData = async (locale: string, id: number) => {
  try {
    const basePopulates = `populate[0]=Media.Media&populate[1]=Content&populate[2]=Category&filters[pid][$eq]=${id}`;
    const query = locale ? `posts?locale=${locale}&${basePopulates}` : `posts?${basePopulates}`;
    const response = await apiClient.get(query);
    return response.data;
  } catch (error) {
    console.error('Error fetching latest updates post data:', error);
    throw error;
  }
};

export const getHomeLatestUpdatesPostData = async (locale: string) => {
  try {
    const basePopulates = 'populate[0]=Media.Media&populate[1]=Content&populate[2]=Category&pagination[pageSize]=3';
    const query = locale ? `posts?locale=${locale}&${basePopulates}&sort[4]=Date:desc` : `latest-update?${basePopulates}`;
    const response = await apiClient.get(query);
    return response.data;
  } catch (error) {
    console.error('Error fetching latest updates post data:', error);
    throw error;
  }
};

export const getNewsCategoriesData = async () => {
  try {
    const basePopulates = `populate=*`;
    const query = `news-categories?${basePopulates}&sort=Name:asc`;
    const response = await apiClient.get(query);
    return response.data;
  } catch (error) {
    console.error('Error fetching news categories data:', error);
    throw error;
  }
};

export const getFontSizeData = async (locale: string) => {
  try {
    const query = locale ? `font-size?locale=${locale}` : `font-size`;
    const response = await apiClient.get(query);
    return response.data;
  } catch (error) {
    console.error('Error fetching font size data:', error);
    throw error;
  }
};

export const getBusinessPartnerItem = async (locale: string) => {
  try {
    const basePopulates = 'populate[0]=Partner&populate[1]=Partner.Partner_category&populate[2]=Partner.Logo';
    const query = locale ? `business-partner?${basePopulates}` : `business-partner?${basePopulates}`;
    const response = await apiClient.get(query);
    return response.data;
  } catch (error) {
    console.error('Error fetching business partner data:', error);
    throw error;
  }
};

export const getBusinessPartnerCategories = async () => {
  try {
    const basePopulates = 'populate=*';
    const query = `partner-categories?${basePopulates}&sort=Order:asc`;
    const response = await apiClient.get(query);
    return response.data;
  } catch (error) {
    console.error('Error fetching business partner data:', error);
    throw error;
  }
};


